import { MaterialReactTable } from 'material-react-table';
import OWContainer from 'styles/styled-components/ow-container';
import useController from '../controllers/websites-controller';

export const WebsitesRoute = () => {
    const { tableSettings } = useController();
    return (
        <OWContainer>
            <MaterialReactTable table={tableSettings} />
        </OWContainer>
    );
};
